import { useState } from 'react'
import HelpPanel from './HelpPanel.jsx'

// Right-edge sticky tab pinned across every route. Mounted once in App.jsx.
export default function HelpButton() {
  const [open, setOpen] = useState(false)

  return (
    <>
      <button
        type="button"
        aria-label="Report a problem"
        onClick={() => setOpen(true)}
        /* #354 exception: not a button role. This is a fixed edge tab rotated
           against the viewport, so rounded-full / px-4 / 44px would make it a
           different object, not a consistent one. It keeps its own spelling
           and its own focus ring. */
        className="fixed right-0 top-1/2 z-40 -translate-y-1/2 translate-x-0 rounded-r-md bg-brand-600 px-2 py-3 text-xs font-medium uppercase tracking-wider text-white shadow-lg hover:bg-brand-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-400"
        style={{ writingMode: 'vertical-rl', transform: 'translateY(-50%) rotate(180deg)' }}
      >
        Help
      </button>
      <HelpPanel open={open} onClose={() => setOpen(false)} />
    </>
  )
}
